import React, { useState } from "react";
import {
  Box,
  Button,
  Stepper,
  Step,
  StepLabel,
  Typography,
  TextField, 
  Select,
  MenuItem,
  IconButton,
  InputAdornment,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DeleteIcon from "@mui/icons-material/Delete";
import Grid from '@mui/material/GridLegacy';

const OrganizationSelectionStep = ({ onNext }) => {
	const [orgName, setOrgName] = useState("");
	  const [website, setWebsite] = useState("");


  const [teamMembers, setTeamMembers] = useState([
    { email: "", role: "User" },
  ]);
  const inviteLink = "https://app.timetracker.com/organizations/invite/xyz";
	  
		const handleAddMember = () => {
		  setTeamMembers([...teamMembers, { email: "", role: "User" }]);
		};
	  
		const handleMemberChange = (index, field, value) => {
		  const updated = [...teamMembers];
		  updated[index][field] = value;
		  setTeamMembers(updated);
		};
	  
		const handleCopyLink = () => {
		  navigator.clipboard.writeText(inviteLink);
		  alert("Link copied to clipboard");
		};
	  const handleRemoveMember = (indexToRemove) => {
		const updated = teamMembers.filter((_, idx) => idx !== indexToRemove);
		setTeamMembers(updated);
	  };
  return (
	 <Box sx={{ maxWidth: 800, mx: "auto", mt: 5 }}>
      {/* Heading */}
      <Typography gutterBottom sx={{fontSize:"18px", color:'#1A1F36', fontWeight:'600',}}>
        Confirm your organization info
      </Typography>
      <Typography variant="body2" mb={3} sx={{fontSize:"14px", color:'#1A1F36', fontWeight:'400',}}>
        Review and confirm your organization details to make sure everything is accurate before moving forward with your team setup.
      </Typography>

      {/* Org Name & Website */}
	  <Box mb={1}>
		 <Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#363853", mb:0.7 }}>
				 Organization name
				</Typography>
      <TextField
        fullWidth
        required 
        placeholder="Enter your Organization name"
        value={orgName}
        onChange={(e) => setOrgName(e.target.value)}
        margin="normal"
		  sx={{
			mt:0,
    "& .MuiInputBase-root": {
      height: 40,
      fontSize: "14px",
    },
    "& .MuiSelect-select": {
      display: "flex",
      alignItems: "center",
      height: "100%",
    },
    "& .MuiMenuItem-root": {
      fontSize: "14px",
      minHeight: 40,
    },
  }}
      />
	  </Box>
	  <Box mb={1}> 
		 <Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#363853", mb:0.7 }}>
				Website
				</Typography>
      <TextField
        fullWidth 
        placeholder="Enter company website (optional)"
        value={website}
        onChange={(e) => setWebsite(e.target.value)}
        margin="normal"
		 sx={{
			mt:0,
    "& .MuiInputBase-root": {
      height: 40,
      fontSize: "14px",
    },
    "& .MuiSelect-select": {
      display: "flex",
      alignItems: "center",
      height: "100%",
    },
    "& .MuiMenuItem-root": {
      fontSize: "14px",
      minHeight: 40,
    },
  }}
      />
</Box>
      <Box mt={5}>
        {/* Invite Your Team Section */}
        <Typography sx={{fontSize:"18px", color:'#1A1F36', fontWeight:'600',}} gutterBottom>
          Invite your team
        </Typography>
        <Typography variant="body2" mb={1} sx={{fontSize:"14px", color:'#1A1F36', fontWeight:'400',}}>
          Timetracker is best when used with your team.
        </Typography>
        <Typography variant="body2" mb={3} sx={{fontSize:"14px", color:'#1A1F36', fontWeight:'400',}}>
          You can invite team members to your organization using the link below or send them an invite via email.
        </Typography> 
        <Typography mb={3} sx={{fontSize:"18px", color:'#1A1F36', fontWeight:'600',}}>
          Invite members via email
        </Typography> 
        {/* Email + Role */}
     
   
    <Box item xs={6} sx={{pt:0}}> 
		<Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#363853", mb:0.7 }}>Invite members via email</Typography>
     {teamMembers.map((member, index) => (
    <Box key={index} sx={{py:0.3}}>
	 <Box sx={{display:'flex', alignItems:'start', gap:1.5, justifyContent:'flex-start',}}>
		 <TextField
        fullWidth
        placeholder="Eg. john@company.com"
        value={member.email}
        onChange={(e) =>
          handleMemberChange(index, "email", e.target.value)
        }
		 sx={{
			mt:0,
    "& .MuiInputBase-root": {
      height: 40,
      fontSize: "14px",
    },
    "& .MuiSelect-select": {
      display: "flex",
      alignItems: "center",
      height: "100%",
    },
    "& .MuiMenuItem-root": {
      fontSize: "14px",
      minHeight: 40,
    },
  }}
      /> 
      <Select
        fullWidth
        value={member.role}
        onChange={(e) =>
          handleMemberChange(index, "role", e.target.value)
        }
		sx={{
			height: '40px',
			maxWidth:"100px",
			fontSize:'13px',
    '& .MuiSelect-select': {
      height: '40px',
	  fontSize:'13px',
	  maxWidth:"100px",
	  py:0,
      display: 'flex',
      alignItems: 'center',
    }
  }}
      >
        <MenuItem value="User" sx={{fontSize:'13px'}}>User</MenuItem>
        <MenuItem value="Admin" sx={{fontSize:'13px'}}>Manager</MenuItem>
      </Select>
          <Box sx={{ width: 60, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
	   {index > 0 && (
        <IconButton
          color="error"
          onClick={() => handleRemoveMember(index)}
        >
          <DeleteIcon />
        </IconButton>
      )}
	 </Box>  
	 </Box>  
	  </Box>
	  ))}
    </Box>
   




        <Typography variant="caption" display="block" mt={1} mb={0}>
          You can always invite more members later.
        </Typography>

        <Button onClick={handleAddMember} sx={{ mb: 3, color:'#0076FE', textTransform:'capitalize', fontSize:'13px', '&:hover':{background:'none',} }}>
          + Add another member
        </Button>

        {/* Invite Link */}
        <Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#363853", mb:0.7 }} gutterBottom>
          Send an invite link
        </Typography>

        <TextField
          fullWidth
          value={inviteLink}
          InputProps={{
            readOnly: true,
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={handleCopyLink}>
                  <ContentCopyIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
		   sx={{
			mt:0,
    "& .MuiInputBase-root": {
      height: 40,
      fontSize: "14px",
    },
    "& .MuiSelect-select": {
      display: "flex",
      alignItems: "center",
      height: "100%",
    },
    "& .MuiMenuItem-root": {
      fontSize: "14px",
      minHeight: 40,
    },
  }}
        />

        <Typography variant="caption" display="block" mt={1}>
          Copy the link to send to your team.
        </Typography>
      </Box>
	   <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
        <Button
          onClick={onNext}
          sx={{
            background: "#0B57D0",
            color: "#fff",
            textTransform: "capitalize",
            fontSize: "14px",
            px: 3,
          }}
        >
          Next
        </Button>
      </Box>
    </Box>
  )
}

export default OrganizationSelectionStep
